module.exports = __webpack_public_path__ + "static/media/fireplace_audio.f8d1b38c.mp4";